import { useEffect, useRef, useState } from 'react';
import BundlePreview from './bundle_preview';
export const useBundlePreview = (bundle) => {
    const previewRef = useRef(null);
    const [isBundleLoaded, setIsBundleLoaded] = useState(false);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            setIsBundleLoaded(false);
            previewRef.current = null;
            if (!bundle) {
                return;
            }
            const preview = new BundlePreview();
            await preview.loadBundle(bundle);
            // Publish the instance only if we’re still mounted
            if (!cancelled) {
                previewRef.current = preview;
                setIsBundleLoaded(true);
            }
        })();
        return () => {
            cancelled = true;
            previewRef.current = null;
        };
    }, [bundle]);
    return { bundlePreview: isBundleLoaded ? previewRef.current : null };
};
export default useBundlePreview;
